import { NgModule } from '@angular/core'
import { NavbarComponent } from '@tv3/layout/navbar/navbar.component'
import { SearchComponent } from '@tv3/layout/navbar/search/search.component'
import { SharedModule } from '@tv3/shared/shared.module'
import { NotificationsComponent } from '@tv3/layout/navbar/notifications/notifications.component'
import { MessagesIconComponent } from './navbar/messages-icon/messages-icon.component'
import { RatesSharedModule } from '@tv3/containers/rates/rates-shared.module'
import { AiResponderModule } from '@tv3/containers/ai-responder/ai-responder.module'
import { Sidebar2Component } from './sidebar2/sidebar.component'
import { OverlayModule } from '@angular/cdk/overlay'
import { CalendarSharedModule } from '@tv3/containers/calendar/shared/calendar-shared.module'
import { RentalsSharedModule } from '@tv3/containers/rentals/rentals-shared.module'
import { InquiriesSharedModule } from '@tv3/containers/inquiries/shared/inquiries-shared.module'
import { GuestsSharedModule } from '@tv3/containers/guests/guests-shared.module'
import { ChannelSharedModule } from '@tv3/containers/channels/shared/channel-shared.module'
import { SettingsSharedModule } from '@tv3/containers/settings/settings-shared.module'
import { BillingLibModule } from '@tokeet-frontend/billing'
import { MessagingSettingsModule } from '@tv3/containers/messaging-settings/messaging-settings.module'
import { ContractsSharedModule } from '@tv3/containers/documents/contracts/contracts-shared.module'
import { AiChatOverlayComponent } from './ai-chat-overlay/ai-chat-overlay.component'
import { AIChatOverlayService } from './ai-chat-overlay/ai-chat-overlay.service'
import { AiModule } from '@tokeet-frontend/ai'
import { SearchResultsDialogComponent } from './navbar/search-results-dialog/search-results-dialog.component'
import { BookingResultsTableComponent } from './navbar/search-results-dialog/booking/booking-results-table.component'
import { InvoiceResultsTableComponent } from './navbar/search-results-dialog/invoice/invoice-results-table.component'
import { GuestResultsTableComponent } from './navbar/search-results-dialog/guest/guest-results-table.component'
import { HoldResultsTableComponent } from './navbar/search-results-dialog/hold/hold-results-table.component'
import { RentalResultsTableComponent } from './navbar/search-results-dialog/rental/rental-results-table.component'
import { GlobalPlusBtnComponent } from './navbar/global-plus-btn/global-plus-btn.component'
import { SystemNotificationsOverlayComponent } from './system-notifications-overlay/system-notifications-overlay.component'
import { SystemNotificationsOverlayService } from './system-notifications-overlay/system-notifications-overlay.service'
import { IncidentLibraryModule } from '@tokeet-frontend/incident'
import { TasksSharedModule } from '@tv3/containers/tasks/tasks-shared.module'

const pipes = []

const dialogs = []

const declarations = [
  ...pipes,
  ...dialogs,
  NavbarComponent,
  SearchComponent,
  GlobalPlusBtnComponent,
  NotificationsComponent,
  MessagesIconComponent,
  Sidebar2Component,
  AiChatOverlayComponent,
  SearchResultsDialogComponent,
  BookingResultsTableComponent,
  InvoiceResultsTableComponent,
  GuestResultsTableComponent,
  HoldResultsTableComponent,
  RentalResultsTableComponent,
  SystemNotificationsOverlayComponent,
]

const modules = [
  SharedModule,
  OverlayModule,
  RatesSharedModule,
  AiResponderModule,
  RentalsSharedModule,
  InquiriesSharedModule,
  CalendarSharedModule,
  GuestsSharedModule,
  ChannelSharedModule,
  SettingsSharedModule,
  BillingLibModule,
  MessagingSettingsModule,
  ContractsSharedModule,
  AiModule,
  IncidentLibraryModule,
  TasksSharedModule,
]

@NgModule({
  imports: [...modules],
  declarations,
  exports: [...declarations, ...modules],
  providers: [...pipes, AIChatOverlayService, SystemNotificationsOverlayService],
})
export class LayoutModule {}
